import { Grid } from '@material-ui/core';
import { UnidadeState, UnidadeViewModel } from '@models/Unidade';
import { UnidadePageContext } from '@pages/UnidadePage/UnidadePageContext';
import React, { memo, useContext, useEffect, useMemo } from 'react';
import PermissaoAplicativoAluno from '../PermissaoAplicativoAluno';
import UnidadeEditar from '../UnidadeEditar';
import UnidadeUsuarioList from '../UnidadeUsuarioList';

// import { Container } from './styles';
interface UnidadeTabContentProps {
    unidadeCurrent: UnidadeViewModel;
    state: UnidadeState
}
const UnidadeTabContent: React.FC<UnidadeTabContentProps> = ({ unidadeCurrent, state }) => {

    // const unidadeContext = useContext(UnidadePageContext);
    // useEffect(() => {
    //     if (unidadeCurrent.usuarios) return;

    //     async function init() {
         

    //     }

    //     init();
    // }, [unidadeCurrent])
    return <>
          {console.log('tab')}
        <Grid container spacing={2}>
            <Grid item md={7} xs={12}>
                <PermissaoAplicativoAluno nivelAppAluno={state.nivelAplicativoAluno} />
                <UnidadeUsuarioList unidadeCurrent={unidadeCurrent} />
            </Grid>
            <Grid item md={5}  xs={12}>
                <UnidadeEditar unidadeCurrent={unidadeCurrent} />
            </Grid>

        </Grid>

    </>;
}

export default memo(UnidadeTabContent);
